import { AxiosResponse } from "axios";
import { saveAs } from "file-saver";
import React, {
  JSXElementConstructor,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { BiUserPin } from "react-icons/bi";
import { BsCloudArrowDownFill } from "react-icons/bs";
import { FaCalendarAlt } from "react-icons/fa";
import { GoCheck } from "react-icons/go";
import { HiDocumentText, HiOutlineRefresh } from "react-icons/hi";
import { ImUserCheck } from "react-icons/im";
import { IoCloseSharp } from "react-icons/io5";
import { LuMailX } from "react-icons/lu";
import {
  MdDelete,
  MdModeEditOutline,
  MdOutlineAttachEmail,
  MdOutlineSchedule,
} from "react-icons/md";
import { SiConvertio } from "react-icons/si";
import { TbHistory } from "react-icons/tb";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { Popover, Whisper } from "rsuite";
import { TypeAttributes } from "rsuite/esm/@types/common";
import { OverlayTriggerType } from "rsuite/esm/Overlay/OverlayTrigger";
import Swal from "sweetalert2";
import AddDesignationModal from "../../component/configuration/Designation/AddDesignationModal";
import AddMeetingCredentials from "../../component/configuration/MeetingCredentials/addMeetingCredentials";
import AddSourceModal from "../../component/configuration/ManageSources/AddSourceModal";
import AddProjectModal from "../../component/configuration/Project/AddProjectModal";
import AddSkillModal from "../../component/configuration/Skill/AddSkillModal";
import { UserContext } from "../../component/layout/layout";
import AssignRecruitersModal from "../../component/manageRequest/assignRecruitersModal";
import CancelRequestModal from "../../component/manageRequest/cancelRequestModal";
import RejectRequestModal from "../../component/manageRequest/rejectRequestModal";
import AddRoleModal from "../../component/Roles/AddRoleModal";
import RescheduleInterviewModal from "../../component/viewRequestDetail/Tabs/ScheduleCandidateTab/RescheduleInterviewModal";
import {
  candidateresume,
  ConvertCallingCandidateToCandidate,
  createCandidateHistory,
  deleteCallingCandidateDetail,
  deleteCandidate,
  deleteLetterEvent,
  DeleteDesignation,
  DeleteEducationDegree,
  deleteInterviewPanel,
  deleteMeetingCredentials,
  DeleteProject,
  deleteRequestById,
  DeleteRole,
  DeleteSkill,
  DeleteSource,
  DeleteTechnology,
  deleteUser,
  inviteUser,
  sendRejectionMail,
} from "../utils/api";
import { AuthType, CommonConstants } from "../utils/CommonConstants";
import {
  axiosDelete,
  axiosGet,
  axiosPatch,
  axiosPost,
  axiosRemove,
  checkCurrentRoleIsSuperAdmin,
} from "../utils/helper";
import { EPConfirmationDialog } from "./confirmationDialog";
// import "../../component/configuration/InterviewPanel/InterviewPanelModal.scss";
const LeadTimeModal = React.lazy(
  () => import("../../component/configuration/leadTimeModal")
);
const ApproveRequestModal = React.lazy(
  () => import("../../component/manageRequest/approveRequestModal")
);
const AddTechnologyModal = React.lazy(
  () =>
    import("../../component/configuration/TechnologyList/AddTechnologyModal")
);
const InterviewPanelModal = React.lazy(
  () =>
    import("../../component/configuration/InterviewPanel/InterviewPanelModal")
);

const AddEducationModal = React.lazy(
  () =>
    import("../../component/configuration/ManageEducation/AddEducationModal")
);
const ReviseDetailsModel = React.lazy(
  () => import("../../component/manageRequest/reviseDetailsModel")
);

interface RowData {
  JDId: any;
  RequirementId: number;
  NoOfRequirement: number;
  StatusName: string;
}
interface Props {
  placement?: TypeAttributes.Placement;
  trigger?: OverlayTriggerType;
  triggerComp: ReactElement<any, string | JSXElementConstructor<any>>;
  rowData: any;
  RequirementId?: any;
  data: Array<any>;
  setDataList: any;
  functionMethod?: any;
  setRefresher?: React.Dispatch<React.SetStateAction<boolean>>;
  refresher?: boolean;
  listName?: string;
  PageAccess?: string[];
  totalRecords?: any;
  setLoading?: any;
  availableLimit?: number;
  setAvailableLimit?: any;
}
// Allow to fill feedback before 15min of schedule date time
export const isFeedBackAllow = (scheduleDateTimeString: string) => {
  const scheduleDateTime = new Date(scheduleDateTimeString);

  // Subtract 15 minutes (15 * 60 * 1000 milliseconds)
  const scheduleTimeMinus15Minutes = new Date(
    scheduleDateTime.getTime() - 15 * 60 * 1000
  );

  const currentTime = new Date();
  const shouldShowFeedbackIcon = currentTime >= scheduleTimeMinus15Minutes;
  if (shouldShowFeedbackIcon) {
    return true;
  } else {
    return false;
  }
};
export const EPOverLay: React.FC<Props> = ({
  rowData,
  triggerComp,
  placement = "top",
  trigger = "hover",
  data,
  setDataList,
  functionMethod,
  setRefresher,
  RequirementId,
  refresher,
  listName,
  PageAccess,
  totalRecords,
  setLoading,
  availableLimit,
  setAvailableLimit,
}) => {
  const { user, setUser }: any = useContext(UserContext);
  const [paths, setPaths] = useState<Array<string>>([]);

  const [open, setOpen] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openLeadModal, setLeadModal] = useState(false);
  const [openSkillModal, setSkillModal] = useState<boolean>(false);
  const [openProjectModal, setProjectModal] = useState<boolean>(false);
  const [openDesignationModal, setDesignationModal] = useState<boolean>(false);
  const [openRoleModal, setRoleModal] = useState<boolean>(false);
  const [openMeetingCredentialModal, setMeetingCredentialModal] =
    useState<boolean>(false);
  const [openSourceModal, setSourceModal] = useState<boolean>(false);
  const [openAddEducationModal, setopenAddEducationModa] = useState(false);
  const [openInterviewPanelModal, setOpenInterviewPanelModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openRescheduleInterviewModel, setopenRescheduleInterviewModel] =
    useState(false);
  const [reSchedule, setReSchedule] = useState<boolean>(false);
  const [fileUrl, setFileUrl] = useState(null);
  const EditAccessData =
    PageAccess?.includes("Edit") || PageAccess?.includes("All");
  const DeleteAccessData =
    PageAccess?.includes("Delete") || PageAccess?.includes("All");
  const navigate = useNavigate();
  const [openAddTechnologyModal, setOpenAddTechnologyModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [EditeId, setEditeId] = useState<any>(null);
  const [reviseDetailsModel, setOpenReviseDetailsModel] = useState(false);
  // console.log("DeleteAccessData>>>>>>>>>>>", DeleteAccessData);
  const candidateStatusForScheduleInterview = [
    "Offered",
    "Accepted",
    "Drop Out",
    "Joined",
    "Blacklist",
    "Draft",
    "New",
  ];
  const candidateStatusForReconsider = ["Rejected", "Declined", "On Hold"];
  const candidateFeedBackStatus = [
    "Needs Second Opinion",
    "Suitable",
    "Can be considered",
    "Rejected",
  ];
  useEffect(() => {
    setPaths(user?.access);
  });
  function handleCross(listName: any, Name?: string) {
    if (listName === "ScheduleData") {
      if (Name === "CancelSchedule") {
        if (
          ![
            "Needs Second Opinion",
            "Suitable",
            "Can be considered",
            "Rejected",
          ].includes(rowData?.StatusId?.trim())
        ) {
          setReSchedule(false);
        } else {
          return;
        }
      } else {
        setReSchedule(true);
      }
      setopenRescheduleInterviewModel(true);
    } else if (listName === "Technology" && rowData.TechnologyCount === 0) {
      setConfirmationModal(true);
    } else if (listName === "manageRequest" && Name === "DeleteRequest") {
      setConfirmationModal(true);
    } else if (listName === "manageRequest") {
      if (
        rowData.StatusName.replace(/\s/g, "").toLowerCase() === "open" &&
        (PageAccess?.includes("Approve") || PageAccess?.includes("All"))
      ) {
        setOpenRejectModal(true);
      }
      // else if (
      //   rowData.StatusName.replace(/\s/g, "").toLowerCase() === "inprogress" &&
      //   !(
      //     (user.roleName && checkCurrentRoleIsSuperAdmin(user.roleName)) ||
      //     user.IsSystemAdmin
      //   )
      // ) {
      //   setOpenCancelModal(true);
      // }
    } else if (
      listName === "manageCandidate" &&
      rowData?.StatusId !== "Interview Scheduled"
    ) {
      setConfirmationModal(true);
    } else if (
      listName === "MeetingConfig" &&
      rowData.ScheduleTypeCount === 0
    ) {
      setConfirmationModal(true);
    } else if (listName === "InterviewPanel") {
      setConfirmationModal(true);
    } else if (listName === "CallingCandidate") {
      setConfirmationModal(true);
    } else if (listName === "SkillList" && rowData.SkillCount === 0) {
      setConfirmationModal(true);
    } else if (listName === "ProjectList" && rowData.ProjectCount === 0) {
      setConfirmationModal(true);
    } else if (
      listName === "DesignationList" &&
      rowData.DesignationCount === 0
    ) {
      setConfirmationModal(true);
    } else if (listName === "RoleList" && rowData.RoleCount === 0) {
      setConfirmationModal(true);
    } else if (listName === "EducationList" && rowData.DegreeCount === 0) {
      setConfirmationModal(true);
    } else if (listName === "SourceList" && rowData.sourceCount === 0) {
      setConfirmationModal(true);
    } else if (listName === "UserList") {
      setConfirmationModal(true);
    } else if (listName === "LetterConfigurationList") {
      setConfirmationModal(true);
    }
  }

  function handleEdit(listName: any) {
    if (listName === "Technology") {
      setOpenAddTechnologyModal(true);
      setEditeId(rowData);
    } else if (listName === "manageRequest") {
      navigate(`/manageRequest/editRequest/${rowData.RequirementId}`);
    } else if (listName === "JDTemplateList") {
      navigate(`/jdTemplate/editJdTemplate/${rowData.JDId}`);
    } else if (listName === "LeadTime") {
      setLeadModal(true);
    } else if (listName === "manageCandidate") {
      navigate(`/manageCandidate/editCandidateDetails/${rowData.CandidateId}`);
    } else if (
      listName === "CallingCandidate" &&
      !rowData.IsConvertedToCandidate
    ) {
      navigate(
        `/callingCandidate/editCallingCandidate/${rowData?.CallingCandidateId}`
      );
    } else if (listName === "InterviewPanel") {
      setOpenInterviewPanelModal(true);
    } else if (listName === "SkillList" && rowData.SkillCount === 0) {
      setSkillModal(true);
    } else if (listName === "ProjectList" && rowData.ProjectCount === 0) {
      setProjectModal(true);
    } else if (
      listName === "DesignationList" &&
      rowData.DesignationCount === 0
    ) {
      setDesignationModal(true);
    } else if (
      listName === "RoleList"
      // && rowData.RoleCount === 0
    ) {
      setRoleModal(true);
    } else if (
      listName === "MeetingConfig" &&
      rowData.ScheduleTypeCount === 0
    ) {
      setMeetingCredentialModal(true);
    } else if (listName === "SourceList") {
      setSourceModal(true);
    } else if (listName === "EducationList" && rowData.DegreeCount === 0) {
      setopenAddEducationModa(true);
    } else if (listName === "UserList") {
      navigate(`/manageUser/editUser/${rowData.EmployeeId}`);
    } else if (listName === "EmailConfigurationList") {
      navigate(`/emailConfiguration/editEmailConfiguration/${rowData.Id}`);
    } else if (listName === "LetterConfigurationList") {
      navigate(`/letterConfiguration/editLetterConfiguration/${rowData.Id}`);
    } else {
      // alert("No Action ");
    }
  }
  async function handelCandidateRemaping() {
    setLoading(true);
    const candidateId = rowData.CandidateId;
    const response = (await axiosPost(`${createCandidateHistory}`, {
      candidateId,
    })) as AxiosResponse;
    setLoading(false);
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      navigate(`/manageCandidate/editCandidateDetails/${rowData.CandidateId}`);
    }
  }

  async function sendRejectionMailToCandidate() {
    setLoading(true);
    const requirementId = rowData?.RequirementId;
    const candidateId = rowData?.CandidateId;
    const candidateEmail = rowData?.Email;
    const candidateName = rowData?.FirstName + " " + rowData?.LastName;

    const response = (await axiosPost(`${sendRejectionMail}/${requirementId}`, {
      candidateEmail,
      candidateName,
      candidateId,
    })) as AxiosResponse;
    setLoading(false);
    setDataList((prevData: any[]) =>
      prevData.map((candidate) =>
        candidate.CandidateId === candidateId
          ? { ...candidate, IsCandidateRejectionEmailSent: true }
          : candidate
      )
    );
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      toast.success("Rejection email send successfully to the candidate!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  function onConfirm() {
    functionMethod(DeleteTechnology, rowData.Id, true);
  }
  function handleView() {
    if (listName === "manageRequest") {
      navigate(`/manageRequest/viewRequest/${rowData.RequirementId}`);
    }
    if (
      listName === "InterviewHistory" &&
      [
        "Needs Second Opinion",
        "Suitable",
        "Can be considered",
        "Rejected",
      ].includes(rowData?.StatusId.trim()) &&
      (PageAccess?.includes("View") || PageAccess?.includes("All"))
    ) {
      navigate(
        `/myInterview/interviewSheetFeedbackView/${rowData.CandidateId}/${rowData.ScheduleId}`
      );
    }
    if (listName === "manageCandidate") {
      navigate(`/manageCandidate/viewCandidateDetails/${rowData.CandidateId}`, {
        state: {
          RoundCount: rowData.RoundCount,
          Round: rowData.Round,
          FirstName: rowData.FirstName,
          LastName: rowData.LastName,
          RequirementId: rowData.RequirementId,
        },
      });
    }
    if (
      (listName?.trim() === "interviewList" && rowData?.OverallAssessment) ||
      (listName?.trim() === "interviewList" && rowData?.IsFeedBackFilled)
    ) {
      // navigate(`/manageCandidate/viewCandidateDetails/${rowData.CandidateId}`);
      navigate(
        `/myInterview/interviewSheetFeedbackView/${rowData.CandidateId}/${rowData.ScheduleId}`
      );
    }
    if (listName === "CallingCandidate") {
      navigate(
        `/callingCandidate/viewCallingCandidate/${rowData.CallingCandidateId}`
      );
    }
    if (listName === "LetterConfigurationList") {
      navigate(`/letterConfiguration/viewLetterConfiguration/${rowData.Id}`);
    }
  }
  const deleteCandidateData = async () => {
    const response = (await axiosPatch(
      `${deleteCandidate}/${rowData.CandidateId}`,
      {}
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    )
      setRefresher(true);
  };

  const deleteMeetingConfigData = async () => {
    const response = (await axiosPatch(
      `${deleteMeetingCredentials}/${rowData.Id}`,
      {}
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success("Platform Deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const deleteCallingCandidateData = async () => {
    const response = (await axiosPatch(
      `${deleteCallingCandidateDetail}/${rowData.CallingCandidateId}`,
      {}
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success("Calling Candidate deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const deleteRequestData = async () => {
    const response = (await axiosPatch(
      `${deleteRequestById}/${rowData.RequirementId}`,
      {}
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };
  const deleteSkill = async () => {
    const response = (await axiosDelete(
      `${DeleteSkill}/${rowData.SkillId}`,
      true
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success("Skill deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const deleteProject = async () => {
    const response = (await axiosDelete(
      `${DeleteProject}/${rowData?.ProjectId}`,
      true
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success("Project deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };
  const deleteRole = async () => {
    const response = (await axiosDelete(
      `${DeleteRole}/${rowData?.RoleId}`,
      true
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success("Role deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const deleteDesignation = async () => {
    const response = (await axiosDelete(
      `${DeleteDesignation}/${rowData?.DesignationId}`,
      true
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success("Designation deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const deleteSource = async () => {
    const response = (await axiosDelete(
      `${DeleteSource}/${rowData.SourceId}`,
      true
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success("Source deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const deleteEducationData = async () => {
    const response = (await axiosDelete(
      `${DeleteEducationDegree}/${rowData.Id}`,
      true
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success("Education deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const deleteInterviewPanelData = async () => {
    const response = (await axiosPatch(
      `${deleteInterviewPanel}/${rowData.InterviewPanelId}`,
      {}
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success("Interview panel deleted successfully.", {
        position: toast.POSITION.TOP_CENTER,
      });
      // setRefresher(true);
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const convertTocandidate = async () => {
    const response = (await axiosGet(
      `${ConvertCallingCandidateToCandidate}/${rowData.CallingCandidateId}`,
      {},
      false
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success(
        "Calling candidate successfully converted into candidate.",
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
      navigate(
        `/manageCandidate/editCandidateDetails/${response.data.data.candidate.CandidateId}`
      );
      // navigate(`/manageCandidate`);
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const onDownload = async () => {
    if (listName?.trim() === "interviewList") {
      let response: any = await axiosGet(
        `${candidateresume}/${rowData.ProfilePath}`,
        {}
      );
      saveAs(
        "data:application/pdf;base64," + String(response.data.pdfBase64),
        `${rowData.ProfilePath}`
      );
    }
    if (listName?.trim() === "candidateFeedback") {
      functionMethod(rowData.CandidateId);
    }
  };

  const onConvert = async () => {
    if (
      listName?.trim() === "CallingCandidate" &&
      !rowData.IsConvertedToCandidate
    ) {
      Swal.fire({
        text: "Are you sure you want to convert this candidate?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result: any) => {
        if (result.isConfirmed) {
          convertTocandidate();
        }
      });
    }
  };

  const inviteEmployee = async () => {
    setLoading(true);
    const response = (await axiosPost(
      `${inviteUser}/${rowData.EmployeeId}`,
      {}
    )) as AxiosResponse;
    setLoading(false);
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const deleteEmployee = async () => {
    const response = (await axiosPatch(
      `${deleteUser}/${rowData.EmployeeId}`,
      {}
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      const toastType = response.data.data.isDelete ? "success" : "error";
      toast[toastType](response.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const deleteLetterConfigurationData = async () => {
    const response = (await axiosRemove(
      `${deleteLetterEvent}/${rowData?.Id}`
    )) as AxiosResponse;
    if (
      response &&
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      setRefresher
    ) {
      toast.success("Letter template deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
      refresher ? setRefresher(false) : setRefresher(true);
    }
  };

  const viewCandidateHistory = () => {
    navigate(`/manageCandidate/candidateHistory/${rowData.CandidateId}`);
  };

  const viewCandidateChatHistory = () => {
    navigate(
      `/myInterview/candidatechatHistory/${rowData.ScheduleId}/${rowData.CandidateId}`
    );
  };
  const speaker = (
    <Popover title="">
      {rowData?.StatusName?.replace(/\s/g, "").toLowerCase() === "inprogress" &&
      (PageAccess?.includes("Assign Recruiter") ||
        PageAccess?.includes("All")) ? (
        <>
          {" "}
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Assign Recruiter</Tooltip>}
          >
            <span>
              <ImUserCheck
                size={18}
                color={"#47BE7D"}
                onClick={() => {
                  setOpen(true);
                }}
              />
            </span>
          </OverlayTrigger>
        </>
      ) : null}
      {rowData?.StatusName?.replace(/\s/g, "").toLowerCase() === "open" &&
      availableLimit &&
      availableLimit > 0 &&
      (PageAccess?.includes("Approve") || PageAccess?.includes("All")) ? (
        <>
          {" "}
          <OverlayTrigger placement="top" overlay={<Tooltip>Approve</Tooltip>}>
            <span>
              <GoCheck
                size={22}
                color={"#47BE7D"}
                onClick={() => {
                  setOpenApproveModal(true);
                }}
              />
            </span>
          </OverlayTrigger>
        </>
      ) : null}
      {rowData?.StatusName?.replace(/\s/g, "").toLowerCase() === "closed" &&
      (PageAccess?.includes("Approve") || PageAccess?.includes("All")) ? (
        <>
          {" "}
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Revise Details</Tooltip>}
          >
            <span>
              <HiOutlineRefresh
                size={22}
                color={"#47BE7D"}
                onClick={() => {
                  setOpenReviseDetailsModel(true);
                }}
              />
            </span>
          </OverlayTrigger>
        </>
      ) : null}
      {(rowData.StatusName &&
        rowData?.StatusName?.replace(/\s/g, "").toLowerCase() === "draft" &&
        (PageAccess?.includes("Delete") || PageAccess?.includes("All"))) ||
      (rowData?.StatusName?.replace(/\s/g, "").toLowerCase() === "open" &&
        (PageAccess?.includes("Delete") || PageAccess?.includes("All"))) ? (
        <>
          <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
            <span>
              <MdDelete
                size={22}
                color={"#EF4D3E"}
                onClick={() => {
                  handleCross(listName, "DeleteRequest");
                }}
              />
            </span>
          </OverlayTrigger>
        </>
      ) : null}
      {listName?.trim() === "UserList" &&
        !rowData?.EmailVerified &&
        user?.authType === AuthType.DEFAULT && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Invite User</Tooltip>}
          >
            <span>
              <MdOutlineAttachEmail
                size={22}
                color={"#00AEEF"}
                onClick={() => {
                  inviteEmployee();
                }}
              />
            </span>
          </OverlayTrigger>
        )}
      {(listName?.trim() === "interviewList" && rowData?.IsFeedBackFilled) ||
      listName === "manageCandidate" ||
      listName === "manageRequest" ||
      listName === "InterviewHistory" ||
      listName === "CallingCandidate" ||
      listName === "LetterConfigurationList" ? (
        <OverlayTrigger
          placement="top"
          overlay={
            listName === "interviewList" ? (
              <Tooltip>View Feedback</Tooltip>
            ) : (
              <Tooltip>View</Tooltip>
            )
          }
        >
          <span>
            <HiDocumentText
              className={`${
                listName === "InterviewHistory" &&
                (![
                  "Needs Second Opinion",
                  "Suitable",
                  "Can be considered",
                  "Rejected",
                ].includes(rowData?.StatusId.trim()) ||
                  !(
                    PageAccess?.includes("Interview History") ||
                    PageAccess?.includes("All")
                  )) &&
                "viewDisable"
              }`}
              size={20}
              color={"#00AEEF"}
              onClick={() => {
                handleView();
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}

      {listName === "manageCandidate" &&
      rowData.RequirementId &&
      rowData.StatusId &&
      rowData.RequestStatus !== CommonConstants.REQUEST_CLOSE_STATUS &&
      (PageAccess?.includes("Schedule") || PageAccess?.includes("All")) &&
      !candidateStatusForScheduleInterview.includes(rowData.StatusId) && // rowData.RoundCount &&
      (rowData.OverallAssessment || !rowData.OverallAssessment) ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Schedule Interview</Tooltip>}
        >
          <span>
            <FaCalendarAlt
              size={16}
              color={"#9A9477"}
              onClick={() => {
                navigate(
                  `/manageCandidate/scheduleInterview/${rowData.CandidateId}`
                );
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}

      {listName === "ScheduleData" ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Reschedule Interview</Tooltip>}
        >
          <span>
            <MdOutlineSchedule
              size={18}
              className={`${
                !(rowData?.StatusId === "Interview Scheduled") &&
                "scheduleDisable"
              }`}
              color={"#5E6772"}
              onClick={() => {
                handleCross(listName);
              }}
              style={{
                pointerEvents:
                  rowData?.StatusId === "Interview Scheduled" ? "auto" : "none",
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}

      {((PageAccess?.includes("Approve") || PageAccess?.includes("All")) &&
        rowData.StatusName &&
        rowData?.StatusName?.replace(/\s/g, "").toLowerCase() === "open") ||
      // rowData?.StatusName?.replace(/\s/g, "").toLowerCase() === "inprogress" ||
      ((listName === "Technology" ||
        listName === "InterviewPanel" ||
        (listName === "manageCandidate" &&
          rowData?.StatusId !== "Interview Scheduled") ||
        listName === "MeetingConfig" ||
        listName === "EducationList" ||
        listName === "SourceList" ||
        listName === "SkillList" ||
        listName === "ProjectList" ||
        listName === "DesignationList" ||
        listName === "LetterConfigurationList" ||
        listName === "CallingCandidate" ||
        (listName === "RoleList" &&
          rowData.Name &&
          !checkCurrentRoleIsSuperAdmin(rowData.Name)) ||
        (listName === "UserList" && rowData.EmployeeId !== user?.EmployeeId)) &&
        DeleteAccessData) ||
      listName === "ScheduleData" ? (
        <>
          <OverlayTrigger
            placement="top"
            overlay={
              rowData?.StatusName === "Open" ? (
                // || rowData?.StatusName === "In Progress"
                <Tooltip>Reject</Tooltip>
              ) : listName === "ScheduleData" ? (
                <Tooltip>Cancel Interview</Tooltip>
              ) : (
                <Tooltip>Delete</Tooltip>
              )
            }
          >
            <span>
              <IoCloseSharp
                size={22}
                className={`${
                  (rowData?.SkillCount && !(rowData.SkillCount === 0)) ||
                  (rowData?.ProjectCount && !(rowData?.ProjectCount === 0)) ||
                  (rowData?.DesignationCount &&
                    !(rowData?.DesignationCount === 0)) ||
                  (rowData?.RoleCount && !(rowData?.RoleCount === 0)) ||
                  (rowData?.ScheduleTypeCount &&
                    !(rowData?.ScheduleTypeCount === 0)) ||
                  (rowData?.DegreeCount && !(rowData.DegreeCount === 0)) ||
                  (rowData?.sourceCount && !(rowData.sourceCount === 0)) ||
                  (rowData?.TechnologyCount &&
                    !(rowData.TechnologyCount === 0)) ||
                  //  ( rowData?.StatusId === "Interview Cancelled")||
                  (rowData?.StatusId === "Interview Cancelled" &&
                    (window.location.href.includes("/viewCandidateDetails") ||
                      window.location.href.includes("/scheduleInterview"))) ||
                  (listName === "ScheduleData" &&
                    [
                      "Needs Second Opinion",
                      "Suitable",
                      "Can be considered",
                      "Rejected",
                    ].includes(rowData?.StatusId?.trim()))
                    ? "closeDisable"
                    : ""
                }
            `}
                color={"#EF4D3E"}
                onClick={() => {
                  handleCross(listName, "CancelSchedule");
                }}
                style={{
                  pointerEvents:
                    (rowData?.StatusId === "Interview Cancelled" &&
                      (window.location.href.includes("/viewCandidateDetails") ||
                        window.location.href.includes("/scheduleInterview"))) ||
                    rowData?.sourceCount
                      ? "none"
                      : "auto",
                }}
              />
            </span>
          </OverlayTrigger>
        </>
      ) : null}
      {(rowData.StatusName &&
        rowData?.StatusName?.replace(/\s/g, "").toLowerCase() === "draft" &&
        EditAccessData) ||
      (rowData.StatusName &&
        ((user.roleName && checkCurrentRoleIsSuperAdmin(user.roleName)) ||
          user.IsSystemAdmin) &&
        !(rowData?.StatusName?.replace(/\s/g, "").toLowerCase() === "cancel") &&
        !(rowData?.StatusName?.replace(/\s/g, "").toLowerCase() === "closed") &&
        EditAccessData) ||
      (listName === "Technology" && EditAccessData) ||
      (listName === "JDTemplateList" && EditAccessData) ||
      (listName === "InterviewPanel" && EditAccessData) ||
      (listName === "manageCandidate" &&
        EditAccessData &&
        !["Joined"].includes(rowData?.StatusId?.trim())) ||
      (listName === "MeetingConfig" && EditAccessData) ||
      (listName === "LeadTime" && EditAccessData) ||
      (listName === "EducationList" && EditAccessData) ||
      (listName === "SkillList" && EditAccessData) ||
      (listName === "ProjectList" && EditAccessData) ||
      (listName === "DesignationList" && EditAccessData) ||
      (listName === "RoleList" &&
        EditAccessData &&
        rowData.Name &&
        !checkCurrentRoleIsSuperAdmin(rowData.Name)) ||
      (listName === "SourceList" && EditAccessData) ||
      (listName === "CallingCandidate" && EditAccessData) ||
      (listName === "EmailConfigurationList" && EditAccessData) ||
      (listName === "LetterConfigurationList" && EditAccessData) ||
      (listName === "UserList" && EditAccessData) ? (
        <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
          <span>
            <MdModeEditOutline
              size={20}
              className={`${
                (rowData?.SkillCount && !(rowData.SkillCount === 0)) ||
                (rowData?.ProjectCount && !(rowData?.ProjectCount === 0)) ||
                (rowData?.DesignationCount &&
                  !(rowData?.DesignationCount === 0)) ||
                // (rowData?.RoleCount && !(rowData?.RoleCount === 0)) ||
                (rowData?.ScheduleTypeCount &&
                  !(rowData?.ScheduleTypeCount === 0)) ||
                (rowData?.DegreeCount && !(rowData.DegreeCount === 0)) ||
                (listName === "CallingCandidate" &&
                  rowData.IsConvertedToCandidate)
                  ? // || (rowData?.sourceCount && !(rowData.sourceCount === 0))
                    "EditDisable"
                  : ""
              }`}
              color={"#F6931E"}
              onClick={() => {
                handleEdit(listName);
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}
      {(listName === "InterviewHistory" ||
        listName?.trim() === "interviewList") &&
      rowData.Round === CommonConstants.VIRTUAL_ROUNDNAME &&
      rowData?.isBotInterviewCompleted ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>InterviewBot History</Tooltip>}
        >
          <span>
            <TbHistory
              size={20}
              color={"#F6931E"}
              onClick={() => {
                viewCandidateChatHistory();
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}

      {/* {candidateStatusForReconsider.includes(rowData.StatusId) &&
      (PageAccess?.includes("Reconsider Candidate") ||
        PageAccess?.includes("All")) &&
      listName === "manageCandidate" ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Reconsider Candidate</Tooltip>}
        >
          <span>
            <SiConvertio
              size={20}
              // className={`${
              //   (rowData?.SkillCount && !(rowData.SkillCount === 0)) ||
              //   (rowData?.ProjectCount && !(rowData?.ProjectCount === 0)) ||
              //   (rowData?.ScheduleTypeCount &&
              //     !(rowData?.ScheduleTypeCount === 0)) ||
              //   (rowData?.DegreeCount && !(rowData.DegreeCount === 0)) ||
              //   (listName === "CallingCandidate" &&
              //     rowData.IsConvertedToCandidate)
              //     ? // || (rowData?.sourceCount && !(rowData.sourceCount === 0))
              //       "EditDisable"
              //     : ""
              // }`}
              color={"#F6931E"}
              onClick={() => {
                handelCandidateRemaping();
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}
      {rowData.IsRequirementMapped &&
      rowData.IsReconsidered &&
      (PageAccess?.includes("Candidate History") ||
        PageAccess?.includes("All")) &&
      listName === "manageCandidate" ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Candidate History</Tooltip>}
        >
          <span>
            <TbHistory
              size={20}
              // className={`${
              //   (rowData?.SkillCount && !(rowData.SkillCount === 0)) ||
              //   (rowData?.ProjectCount && !(rowData?.ProjectCount === 0)) ||
              //   (rowData?.ScheduleTypeCount &&
              //     !(rowData?.ScheduleTypeCount === 0)) ||
              //   (rowData?.DegreeCount && !(rowData.DegreeCount === 0)) ||
              //   (listName === "CallingCandidate" &&
              //     rowData.IsConvertedToCandidate)
              //     ? // || (rowData?.sourceCount && !(rowData.sourceCount === 0))
              //       "EditDisable"
              //     : ""
              // }`}
              color={"#F6931E"}
              onClick={() => {
                viewCandidateHistory();
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null} */}

      {rowData?.StatusId === "Rejected" && listName === "manageCandidate" ? (
        <OverlayTrigger
          placement="top"
          overlay={
            rowData?.IsCandidateRejectionEmailSent ? (
              <Tooltip>Rejection Email Sent</Tooltip>
            ) : (
              <Tooltip>Send Rejection Mail</Tooltip>
            )
          }
        >
          <span>
            <LuMailX
              size={20}
              color={"#EF4D3E"}
              className={`${
                listName === "manageCandidate" &&
                rowData?.IsCandidateRejectionEmailSent
                  ? "rejectEmailDisabled"
                  : ""
              }`}
              onClick={() => {
                sendRejectionMailToCandidate();
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}

      {listName?.trim() === "interviewList" &&
      !rowData?.OverallAssessment &&
      rowData?.RequirementId &&
      !rowData?.IsDraft &&
      [rowData?.PrimaryInterviewerId, rowData?.SecondaryInterviewerId].includes(
        user?.EmployeeId
      ) ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Fill Feedback</Tooltip>}
        >
          <span>
            <BiUserPin
              className={
                !isFeedBackAllow(rowData?.Schedule) ||
                !rowData?.isBotInterviewCompleted
                  ? "viewDisable"
                  : ""
              }
              size={20}
              color={"#7D8491"}
              onClick={() => {
                isFeedBackAllow(rowData?.Schedule) &&
                  rowData?.isBotInterviewCompleted &&
                  navigate(
                    `/myInterview/interviewSheetFeedback/${rowData.ScheduleId}/${rowData.RequirementId}`
                  );
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}

      {listName?.trim() === "interviewList" && rowData?.IsDraft ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Edit Feedback</Tooltip>}
        >
          <span>
            <MdModeEditOutline
              size={20}
              color={"#F6931E"}
              onClick={() => {
                navigate(
                  `/myInterview/interviewSheetFeedback/${rowData.ScheduleId}/${rowData.RequirementId}`
                );
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}

      {listName?.trim() === "CallingCandidate" ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Convert To Candidate</Tooltip>}
        >
          <span>
            <SiConvertio
              size={18}
              className={`${
                listName === "CallingCandidate" &&
                rowData.IsConvertedToCandidate
                  ? "viewDisable"
                  : ""
              }`}
              color={"#1daeef"}
              onClick={() => {
                onConvert();
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}

      {listName?.trim() === "interviewList" ||
      listName?.trim() === "candidateFeedback" ? (
        <OverlayTrigger placement="top" overlay={<Tooltip>Download</Tooltip>}>
          <span>
            <BsCloudArrowDownFill
              size={20}
              color={"#FCA629"}
              onClick={() => {
                onDownload();
              }}
            />
          </span>
        </OverlayTrigger>
      ) : null}
    </Popover>
  );

  return (
    <>
      <Whisper
        enterable
        controlId="control-id-hover-enterable"
        trigger={trigger}
        placement={placement}
        speaker={speaker}
      >
        {triggerComp}
      </Whisper>
      {openApproveModal &&
        (PageAccess?.includes("Approve") || PageAccess?.includes("All")) && (
          <ApproveRequestModal
            setLoading={setLoading}
            open={openApproveModal}
            setOpen={setOpenApproveModal}
            RequirementId={rowData.RequirementId}
            data={data}
            setDataList={setDataList}
            setAvailableLimit={setAvailableLimit}
          />
        )}
      {reviseDetailsModel &&
        (PageAccess?.includes("Approve") || PageAccess?.includes("All")) && (
          <ReviseDetailsModel
            setLoading={setLoading}
            open={reviseDetailsModel}
            setOpen={setOpenReviseDetailsModel}
            RequirementId={rowData.RequirementId}
            data={data}
            setDataList={setDataList}
          />
        )}
      {openRejectModal && (
        <RejectRequestModal
          open={openRejectModal}
          setOpen={setOpenRejectModal}
          RequirementId={rowData.RequirementId}
          data={data}
          setDataList={setDataList}
        />
      )}
      {open && (
        <AssignRecruitersModal
          setLoading={setLoading}
          open={open}
          setOpen={setOpen}
          RequirementId={rowData.RequirementId}
          noOfRequirement={rowData.NoOfRequirement}
        />
      )}

      {openLeadModal && (
        <LeadTimeModal
          open={openLeadModal}
          setLeadModal={setLeadModal}
          singleData={rowData}
          setRefresher={setRefresher}
          ApiType="Update"
          action={"Update"}
          refresher={refresher}
        />
      )}

      {openSkillModal && (
        <AddSkillModal
          open={openSkillModal}
          setOpen={setSkillModal}
          singleData={rowData}
          setRefresher={setRefresher}
          action={"Edit"}
          refresher={refresher}
        />
      )}

      {openProjectModal && (
        <AddProjectModal
          open={openProjectModal}
          setOpen={setProjectModal}
          singleData={rowData}
          setRefresher={setRefresher}
          action={"Edit"}
          refresher={refresher}
        />
      )}
      {openRoleModal && (
        <AddRoleModal
          open={openRoleModal}
          setOpen={setRoleModal}
          singleData={rowData}
          setRefresher={setRefresher}
          action={"Edit"}
          refresher={refresher}
        />
      )}

      {openDesignationModal && (
        <AddDesignationModal
          open={openDesignationModal}
          setOpen={setDesignationModal}
          singleData={rowData}
          setRefresher={setRefresher}
          action={"Edit"}
          refresher={refresher}
        />
      )}

      {openMeetingCredentialModal && (
        <AddMeetingCredentials
          open={openMeetingCredentialModal}
          setOpen={setMeetingCredentialModal}
          singleData={rowData}
          setRefresher={setRefresher}
          action={"Edit"}
          refresher={refresher}
        />
      )}

      {openSourceModal && (
        <AddSourceModal
          open={openSourceModal}
          setOpen={setSourceModal}
          singleData={rowData}
          setRefresher={setRefresher}
          action={"Edit"}
          refresher={refresher}
        />
      )}
      {openAddEducationModal && (
        <AddEducationModal
          open={openAddEducationModal}
          setOpen={setopenAddEducationModa}
          singleData={rowData}
          setRefresher={setRefresher}
          action={"Edit"}
          refresher={refresher}
          totalRecords={totalRecords}
        />
      )}

      {openAddTechnologyModal && (
        <AddTechnologyModal
          open={openAddTechnologyModal}
          EditeId={EditeId}
          setOpen={setOpenAddTechnologyModal}
          action={"Edit"}
          setRefresher={setRefresher}
          refresher={refresher}
        />
      )}

      {openCancelModal && (
        <CancelRequestModal
          open={openCancelModal}
          setOpen={setOpenCancelModal}
          RequirementId={rowData.RequirementId}
          data={data}
          setDataList={setDataList}
        />
      )}
      {openRescheduleInterviewModel && (
        <RescheduleInterviewModal
          singleData={rowData}
          setLoading={setLoading}
          open={openRescheduleInterviewModel}
          reSchedule={reSchedule}
          setOpen={setopenRescheduleInterviewModel}
          action={"Reschedule"}
          setRefresher={setRefresher}
          RequirementId={RequirementId}
          refresher={refresher}
        />
      )}
      {confirmationModal && (
        <EPConfirmationDialog
          open={confirmationModal}
          setOpen={setConfirmationModal}
          confirmDialogTitle={
            listName === "manageCandidate"
              ? "Delete Candidate"
              : listName === "MeetingConfig"
              ? "Delete Meeting Configuration"
              : listName === "InterviewPanel"
              ? "Delete Interview Panel"
              : listName === "SkillList"
              ? "Delete Skill"
              : listName === "ProjectList"
              ? "Delete Project"
              : listName === "DesignationList"
              ? "Delete Designation"
              : listName === "RoleList"
              ? "Delete Role"
              : listName === "EducationList"
              ? "Delete education"
              : listName === "manageRequest"
              ? "Delete Request"
              : listName === "Technology"
              ? "Delete Technology"
              : listName === "requirementMapping"
              ? "Remap Requirement"
              : listName === "CallingCandidate"
              ? "Calling Candidate"
              : listName === "SourceList"
              ? "Delete Source"
              : listName === "UserList"
              ? "Delete User"
              : listName === "LetterConfigurationList"
              ? "Delete Letter Template"
              : (listName as string)
          }
          confirmDialogMessage={
            listName === "manageCandidate"
              ? "Are you sure you want to delete this candidate?"
              : listName === "MeetingConfig"
              ? "Are you sure you want to delete this meeting configuration?"
              : listName === "CallingCandidate"
              ? "Are you sure you want to delete this Calling Candidate?"
              : listName === "SkillList"
              ? "Are you sure you want to delete the skill?"
              : listName === "ProjectList"
              ? "Are you sure you want to delete the project?"
              : listName === "DesignationList"
              ? "Are you sure you want to delete the designation?"
              : listName === "RoleList"
              ? "Are you sure you want to delete the role?"
              : listName === "requirementMapping"
              ? `Are you sure you want to Remap Requirement with Candidate?`
              : listName === "EducationList"
              ? `Are you sure you want to delete the education?`
              : listName === "manageRequest"
              ? `Are you sure you want to delete the Request?`
              : listName === "InterviewPanel"
              ? "Are you sure you want to delete the Interview panel?"
              : listName === "SourceList"
              ? "Are you sure you want to delete the source?"
              : listName === "UserList"
              ? "Are you sure you want to delete the Employee?"
              : listName === "LetterConfigurationList"
              ? "Are you sure you want to delete the letter template?"
              : `Are you sure you want to delete  ${rowData.Name}?`
          }
          confirmButtonText={
            listName === "manageCandidate" ||
            listName === "MeetingConfig" ||
            listName === "CallingCandidate" ||
            listName === "requirementMapping" ||
            listName === "manageRequest" ||
            listName === "InterviewPanel" ||
            listName === "SourceList" ||
            listName === "SkillList" ||
            listName === "ProjectList" ||
            listName === "DesignationList" ||
            listName === "RoleList" ||
            listName === "EducationList" ||
            listName === "UserList" ||
            listName === "LetterConfigurationList"
              ? "Yes"
              : "Confirm"
          }
          cancelButtonText={
            listName === "manageCandidate" ||
            listName === "MeetingConfig" ||
            listName === "CallingCandidate" ||
            listName === "requirementMapping" ||
            listName === "manageRequest" ||
            listName === "InterviewPanel" ||
            listName === "SourceList" ||
            (listName === "SkillList" ? "No" : "Cancel") ||
            (listName === "ProjectList" ? "No" : "Cancel") ||
            (listName === "DesignationList" ? "No" : "Cancel") ||
            (listName === "RoleList" ? "No" : "Cancel") ||
            listName === "EducationList" ||
            listName === "UserList" ||
            listName === "LetterConfigurationList"
              ? "No"
              : "Cancel"
          }
          onConfirm={() =>
            listName === "manageCandidate"
              ? deleteCandidateData()
              : listName === "MeetingConfig"
              ? deleteMeetingConfigData()
              : listName === "CallingCandidate"
              ? functionMethod(
                  deleteCallingCandidateDetail,
                  rowData?.CallingCandidateId
                )
              : listName === "InterviewPanel"
              ? deleteInterviewPanelData()
              : listName === "EducationList"
              ? functionMethod(DeleteEducationDegree, rowData?.Id)
              : listName === "manageRequest"
              ? deleteRequestData()
              : listName === "SkillList"
              ? functionMethod(DeleteSkill, rowData?.SkillId)
              : listName === "ProjectList"
              ? functionMethod(DeleteProject, rowData?.ProjectId)
              : listName === "DesignationList"
              ? functionMethod(DeleteDesignation, rowData?.DesignationId)
              : listName === "RoleList"
              ? functionMethod(DeleteRole, rowData?.RoleId)
              : listName === "SourceList"
              ? functionMethod(DeleteSource, rowData?.SourceId)
              : listName === "UserList"
              ? deleteEmployee()
              : listName === "LetterConfigurationList"
              ? deleteLetterConfigurationData()
              : onConfirm()
          }
        />
      )}
      {openInterviewPanelModal && (
        <InterviewPanelModal
          open={openInterviewPanelModal}
          setOpen={setOpenInterviewPanelModal}
          singleData={rowData}
          action={"Edit"}
          setRefresher={setRefresher}
          refresher={refresher}
        />
      )}
    </>
  );
};
